import { AbilityBuilder, PureAbility } from "@casl/ability";
import { type AuthenticatedUser } from "~/lib/session";
import { Action, type AppAbility, Subject } from "~/services/user/permissions/caslPermissionsType";
import { getUserRoles } from "~/services/user/permissions/utils/getUserRoles";

export const createPermissionsFromUserPermissions = (user: AuthenticatedUser) => {
  const { can, rules } = new AbilityBuilder<AppAbility>(PureAbility);

  if (!user?.permissions) {
    return rules;
  }

  if (getUserRoles(user).isEmployee && user.permissions.canAccessMarketData) {
    can(Action.Access, Subject.MarketData);
  }

  return rules;
};
